// extracted by mini-css-extract-plugin
module.exports = {"list":"article-list_list__18QSC","name":"article-list_name__3H38M"};